export const hourMs = 3.6e6;

export const dayMs = 8.64e7;
